


































































































































































import { Todo, to_do_state, visibility, assignee_type } from "@/types/todo/todo";
import { AttachmentPost } from "@/types/todo/attachment";
import { HyperlinkPost, Hyperlink } from "@/types/todo/hyperlink";
import Toolbar from "../components/toolbar/Toolbar.vue";
import CaseInfo from "@/components/modules/todo/CaseInfo.vue";
import DelegateToDo from "@/components/modules/todo/DelegateToDo.vue";
import FinishToDo from "@/components/modules/todo/FinishToDo.vue";
import { HyperlinkItem } from "@/types/HyperlinkItem";
import CreateHyperlink from "../components/dialogs/CreateHyperlink.vue";
import ZenyaDialog, { IZenyaDialog } from "../components/dialogs/ZenyaDialog.vue";
import { ApiErrorType, SourceType, SavingState } from "@/enums";
import Vue from "vue";
import { Attachment } from "@/types/todo/attachment";
import Upload from "@/controls/upload.vue";
import { updateToDoAsync, getTodoAsync, addHyperlinkAsync, deleteHyperlinkAsync, addAttachmentAsync, deleteAttachmentAsync } from "@/todos";
import Utils, { debounce } from "@/utils";
import Shared from "@/shared";
import Alert from "../components/alerts/alert.vue";
import { Case } from "@/types/case/case";
import { CaseType } from "@/types/case/caseType";
import { Controllers } from "@infoland/iprova-api";

export default Vue.extend({
    name: "HandleTodo",
    props: {
        todoId: Number
    },
    components: { CaseInfo, DelegateToDo, Toolbar, ZenyaDialog, CreateHyperlink, Upload, Alert, FinishToDo },
    data: () => ({
        todo: null as Todo,
        files: [] as Attachment[],
        existingTodoFiles: [] as Attachment[],
        hyperlinks: [] as Hyperlink[],
        text: null as string,
        showCreateHyperlink: false,
        sourceType: SourceType.ToDo,
        displayFinishDialog: false,
        todoProgressNote: null,
        todoModified: false,
        errorType: null,
        errorMessage: null,
        displayDelegateToDoDialog: false,
        toDoCase: null as Case,
        hideDelegateOkButton: false,
        actorsCanDelegateToDo: false,
        actorIDs: null as string[],
        savingState: SavingState,
        todoSavingState: SavingState.NotSaved,
        savedTime: null as String,
        assigneeTypeTeam: assignee_type.team
    }),

    watch: {
        todoId: {
            handler(newValue, oldValue) {
                this.initTodo(newValue);
            },
            immediate: true
        },
        todoSavingState: {
            handler(newValue: SavingState, oldValue: SavingState) {
                if (oldValue === SavingState.isSaving && newValue === SavingState.Saved) {
                    const date = new Date();
                    this.savedTime =
                        `${"0" + date.getHours()}`.slice(-2) +
                        ":" +
                        `${"0" + date.getMinutes()}`.slice(-2) +
                        ":" +
                        `${"0" + date.getSeconds()}`.slice(-2);
                }
            }
        }
    },
    methods: {
        toCalendar(date: Date): string {
            return Utils.toCalendar(date);
        },
        clickOutside(): void {
            this.displayFinishDialog = false;
        },

        async deleteAttachment(attachment_id, index) {
            this.todoSavingState = SavingState.isSaving;
            this.files.splice(index, 1);
            await deleteAttachmentAsync(attachment_id);
            this.todoSavingState = SavingState.Saved;
        },
        async updateFiles(newFile) {
            this.todoSavingState = SavingState.isSaving;
            const contentBase64 = newFile.file;
            const extension = (newFile.title as string).split(".")[1];
            const attachmentPost: AttachmentPost = {
                file_extension: extension,
                base_64_file: contentBase64.toString(),
                title: (newFile.title as string).split(".")[0],
                visibility: visibility.public
            };
            const response = await addAttachmentAsync(this.todoId, attachmentPost);
            if (response.success) {
                await this.setTodoInProgress(this.todo);
                this.files.push({
                    attachment_id: response.successData,
                    title: newFile.title,
                    url: Shared.GetAuthenticatedUrl(Shared.iProvaApiUrl + "/" + `cases/attachments/${response.successData}/download`),
                    file_extension: extension,
                    mime_type: newFile.mime_type
                } as Attachment);
                this.todoSavingState = SavingState.Saved;
            }
        },
        openCreateHyperlink() {
            this.showCreateHyperlink = true;
        },
        openHyperlink(hyperlink_id: string) {
            this.$router.push({ name: "hyperlink", params: { hyperlink_id: hyperlink_id } });
        },
        async deleteHyperlink(hyperlink_id: number) {
            this.todoSavingState = SavingState.isSaving;
            await deleteHyperlinkAsync(hyperlink_id);
            var index = this.hyperlinks.findIndex(function (o) {
                return o.hyperlink_id === hyperlink_id;
            });
            if (index !== -1) this.hyperlinks.splice(index, 1);
            this.todoSavingState = SavingState.Saved;
        },
        async closeCreateHyperlink(hyperlinkItem: HyperlinkItem) {
            this.todoSavingState = SavingState.isSaving;
            if (hyperlinkItem != null) {
                const hyperlinkPost: HyperlinkPost = {
                    hyperlink_id: hyperlinkItem.id,
                    description: hyperlinkItem.description,
                    visibility: visibility.public
                };
                var response = await addHyperlinkAsync(this.todoId, hyperlinkPost);
                if (response.success) {
                    this.hyperlinks.push({
                        hyperlink_id: parseInt(response.successData),
                        hyperlink_target_id: hyperlinkItem.id,
                        description: hyperlinkItem.description
                    });
                    await this.setTodoInProgress(this.todo);
                    this.todoSavingState = SavingState.Saved;
                }
            }
            this.showCreateHyperlink = false;
        },
        async setTodoInProgress(todo: Todo) {
            if (todo && todo.state === to_do_state.new) {
                await updateToDoAsync(this.todoId, {
                    state: to_do_state.active
                });
            }
        },
        async initTodo(todoId: number) {
            const response = await getTodoAsync(todoId);
            if ((response.errorType && response.errorType === ApiErrorType.NotFound) || response.errorType === ApiErrorType.Forbidden) {
                this.errorType = response.errorType;
            } else if (response.todo.state == to_do_state.finished) {
                this.errorType = "finished";
            } else {
                this.todo = response.todo;
                this.todoProgressNote = this.todo.note;
                this.hyperlinks = this.todo.hyperlinks;
                if (this.todo.attachments) {
                    this.todo.attachments.forEach(at => {
                        this.existingTodoFiles.push({
                            title: at.title + at.file_extension,
                            attachment_id: at.attachment_id.toString(),
                            url: Shared.GetAuthenticatedUrl(Shared.iProvaApiUrl + "/" + `cases/attachments/${at.attachment_id}/download`),
                            mime_type: at.mime_type
                        });
                    });
                }
                this.actorIDs = this.todo.resolved_actor_assignees.map(x => x.assignee_id);
                this.files = this.existingTodoFiles;
                this.toDoCase = await this.getTodoCaseAsync();
            }
            if (this.toDoCase) {
                this.actorsCanDelegateToDo = await this.getActorsCanDelegateToDoAsync();
            }
        },
        async getTodoCaseAsync(): Promise<Case> {
            const headers = { "X-Api-Version": "2" }; //force api version 2
            return (await Controllers.GenericController.getAsync<Case[]>(`cases/?case_ids=${this.todo.case_id}`, null, headers))[0];
        },
        async getActorsCanDelegateToDoAsync(): Promise<boolean> {
            let caseType: CaseType = await Controllers.GenericController.getAsync<CaseType>(`cases/case_types/${this.toDoCase.case_type_id}`);
            return caseType.actors_can_delegate_todo;
        },
        updateSaveIcon(): void {
            this.todoSavingState = SavingState.isSaving;
        },
        updateTodoNote: debounce(async function (this: any, value: string): Promise<void> {
            this.todoSavingState = SavingState.isSaving;
            const response = await updateToDoAsync(this.todoId, {
                note: value
            });
            if (!response.success) {
                this.todoProgressNote = this.todo.note;
            }
            await this.setTodoInProgress(this.todo);
            this.todoSavingState = SavingState.Saved;
        }, 2000),
        hideDelegatePopupOkButton(showButton: boolean): void {
            this.hideDelegateOkButton = showButton;
        }
    },

    computed: {
        latestFiles(): Attachment[] {
            return this.files;
        },
        showActors(): Boolean {
            return (
                this.todo.resolved_actor_assignees &&
                (this.todo.resolved_actor_assignees.length > 1 ||
                    (this.todo.resolved_actor_assignees.length == 1 && this.todo.resolved_actor_assignees[0].type == this.assigneeTypeTeam))
            );
        }
    }
});
